import React from 'react'
import Bitcoin from './Bitcoin'
import apple from './images/Group 68.svg'
import google from './images/Group 69.svg'
import { Link } from 'react-router-dom'
import Why from './Why'
import BuyandSell from './BuyandSell'
import Create from './Create'
import Review from './Review'
import Footer from './Footer'
import { FaArrowUp } from 'react-icons/fa';
import { useState } from 'react'



const Homepage = () => {

  let rootElement = document.documentElement

  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 2000){
      setVisible(true)
    } 
    else if (scrolled <= 2000){
      setVisible(false)
    }
  };
  
  window.addEventListener('scroll', toggleVisible);

  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  


  return (
    <div >


       <div className='home'>
       <section className='buy'>
              <h1> Buy, sell and manage your Crypto on TradExpress.</h1>

        </section>

    
        <section className='homepara'>
               <p>Easily Trade Cryptocurrencies like BTC, USDT, ETH, LTC & XRP with NGN.</p>
        </section>

        <Link to='./GetStarted'><button className='start'>Get Started</button></Link>

      <div className='apple'>
      <a href="https://www.apple.com/store" target={'_blank'}><img className='sto' src={apple} alt="" /></a>
      <a href="https://play.google.com/store" target={'_blank'}><img className='sto' src={google} alt="" /></a>
      </div>
       </div>

        <Bitcoin/>
        <Why/>
        <BuyandSell/>
        <Create/>
        <Review/>
        <Footer/>
        <FaArrowUp style={{display: visible ? 'inline' : 'none'}} onClick={scrollToTop} className='arrowup' size={50}/>
    </div>
  )
}

export default Homepage